import * as firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/firestore';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyDnETF1ysageWNTJMHcT7dPC62tHi8qNw8',
  authDomain: 'tectonics-io.firebaseapp.com',
  databaseURL: 'https://tectonics-io.firebaseio.com',
  projectId: 'tectonics-io',
  storageBucket: 'tectonics-io.appspot.com',
  messagingSenderId: '298472082743',
  appId: '1:298472082743:web:897d3f2ec50e186a3b1eb2',
  measurementId: 'G-KLMQQ9ZX15',
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();

const firestore = firebase.firestore();
export {firestore};
